<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XYPccJ/tc-custom/9781448303205.jpg?1705209705056" alt="This image is the cover for the book Ball Park, The Émile Cinq-Mars Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ball Park, The Émile Cinq-Mars Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Getting inside is easy; the stress comes in getting out clean. A case of breaking and entering escalates after Émile Cinq-Mars transfers from the Night Patrol.</i></b><br/><br/><i>Montreal, 1975.</i> Detective Émile Cinq-Mars is transferring from the Night Patrol – the notoriously tough department of officers in charge of watching over the city as it sleeps – to the day shift. His old superior has seen to it that he’s assigned to partner Yves Giroux, another ex-Night Patrol detective some say isn’t on the ‘up and up’.<br/><br/> Getting in a house is easy for thief Quinn Tanner. The stress comes in getting out clean. On finding her getaway driver dead after her latest heist, she goes underground. <br/><br/> For his first case on the day shift, Émile is sent to the property that Quinn has just visited, and their paths are set to cross. But has she stolen something more valuable than she realizes . . . and who is hunting for her now?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Farrow
      </h2>
      
      <p class="authorDescription body article">John Farrow is the pseudonym of Trevor Ferguson, a Canadian novelist and playwright with six previous novels in the Émile Cinq-Mars thriller series and seven literary novels under his own name. Booklist in New York has called his crime series the best of our time. Die Zeit in Germany has called it the best of all time.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?411b833e